import { render, staticRenderFns } from "./SpFieldRecord.vue?vue&type=template&id=4e371060&"
import script from "./SpFieldRecord.vue?vue&type=script&lang=ts&"
export * from "./SpFieldRecord.vue?vue&type=script&lang=ts&"
import style0 from "./SpFieldRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports